import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const SbiBikeLoanEmiCalculator  = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is the minimum loan amount offered by SBI for bike loans?",
            "answer": "SBI usually offers bike loans starting from ₹20,000, but this may vary based on location and eligibility."
          },
          {
            "question": "Can I apply for an SBI bike loan online?",
            "answer": "Yes, SBI offers a fully digital loan application process through its official website or YONO app."
          },
          {
            "question": "What documents are needed to apply for an SBI bike loan?",
            "answer": "You’ll need ID proof, address proof, income proof, bank statements, and a quotation from the bike dealer."
          },
          {
            "question": "Is a guarantor required for the loan?",
            "answer": "Usually not, unless the applicant has a weak credit profile or unstable income."
          },
          {
            "question": "What is the maximum loan tenure available?",
            "answer": "SBI offers bike loan tenures up to 60 months."
          },
          {
            "question": "How is the interest rate determined?",
            "answer": "It depends on your credit score, loan amount, income level, and RBI repo rates."
          },
          {
            "question": "Are there any prepayment penalties?",
            "answer": "SBI allows partial or full prepayments, often with zero or minimal charges."
          },
          {
            "question": "How long does it take to get loan approval?",
            "answer": "Loan approval typically takes 24-48 hours if all documents are in order."
          },
          {
            "question": "Can I get a loan for a second-hand bike?",
            "answer": "Yes, SBI offers used vehicle loans but the rate and terms may differ."
          },
          {
            "question": "Can I transfer my existing bike loan from another bank to SBI?",
            "answer": "Yes, balance transfer options are available with competitive rates."
          },
          {
            "question": "Will my EMI change if interest rates fluctuate?",
            "answer": "For fixed-rate loans, EMI remains unchanged. Floating-rate loans can vary."
          },
          {
            "question": "Can students apply for an SBI bike loan?",
            "answer": "Only if they have a co-applicant or a stable income source."
          },
          {
            "question": "What if I miss an EMI payment?",
            "answer": "You may incur penalties and it could impact your credit score."
          },
          {
            "question": "Does SBI offer special bike loans for electric vehicles?",
            "answer": "Yes, SBI is now offering green loan variants with special benefits for EVs."
          },
          {
            "question": "How do I contact SBI for loan-related queries?",
            "answer": "You can visit the nearest branch, call their customer care, or log in to the official website."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         <title>SBI Bike Loan EMI Calculator – Plan Your Two-Wheeler Loan Easily</title>
        <meta  name='description' content='Calculate EMIs for your SBI bike loan quickly. Use this tool to get accurate monthly repayment estimates and plan your loan better.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/sbi-bank-bike-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">SBI Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
           <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
      <h1 className="text-2xl font-bold mb-4">SBI Bank Bike Loan EMI Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your SBI Bank Bike Loan Payments with TheFinMaster’s EMI Calculator
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Owning a bike can significantly enhance your daily commute, offering convenience, speed, and independence. However, the cost of purchasing a two-wheeler can still be a burden if not planned properly. This is where SBI Bank's Bike Loan options come into play—and to help you navigate the repayment process with absolute clarity, TheFinMaster brings you the most advanced SBI Bank Bike Loan EMI Calculator. Designed to provide instant, transparent, and highly accurate EMI projections, this tool allows you to make informed financial decisions. Whether you're planning to buy a budget-friendly scooter or a high-performance motorcycle, knowing your EMI beforehand helps you stay within budget and avoid repayment stress. Read on to explore everything you need to know about SBI Bank bike loan EMIs, amortisation schedules, and more.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Bike Loan EMI?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Bike Loan EMI (Equated Monthly Installment) is the fixed payment amount a borrower must pay each month to the bank until the full repayment of the loan amount, along with applicable interest. The EMI consists of two components: the principal amount and the interest on the outstanding loan balance. SBI Bank offers flexible repayment options ranging from 12 months to 60 months, allowing borrowers to choose a plan that suits their financial capacity. The EMI amount remains constant throughout the tenure, making it easier to manage monthly expenses and financial planning. By breaking the repayment into manageable monthly outflows, a bike loan EMI ensures you can enjoy the benefits of owning a two-wheeler without facing an immediate financial crunch.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is SBI Bank Bike Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The SBI Bank Bike Loan EMI Calculator is an intuitive online tool offered by TheFinMaster to simplify your financial planning. It helps you calculate the exact EMI amount you will be paying towards your SBI Bank bike loan. By entering basic details like loan amount, interest rate, and loan tenure, you get instant results on your monthly EMI. This calculator eliminates the need for manual calculations and complex formulas. It gives you a clear picture of your repayment journey, including the total interest payable and total repayment amount. Ideal for comparing different loan options or evaluating various tenure scenarios, this tool saves you time, reduces ambiguity, and helps you plan better.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s SBI Bank Bike Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s SBI Bike Loan EMI Calculator offers several key advantages:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Instant Results:</strong> Get your EMI amount in seconds without filling lengthy formsCULATOR or navigating through complex websites.</li>
              <li><strong>100% Accuracy:</strong> The tool uses a standard mathematical formula ensuring you get precise EMI calculations every time.</li>
              <li><strong>Customisation:</strong> Try different combinations of loan amounts, interest rates, and tenures to see what fits best.</li>
              <li><strong>Comprehensive Output:</strong> Besides EMI, the calculator displays total interest payable and overall payment liability.</li>
              <li><strong>Financial Clarity:</strong> By knowing your EMI in advance, you can budget better and avoid loan defaults.</li>
              <li><strong>Accessibility:</strong> It’s free, online, and available 24x7, so you can use it anytime from anywhere.</li>
              <li><strong>Informed Comparisons:</strong> Helps you compare different loan offers and select the one that aligns with your financial goals.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Whether you are a salaried employee, self-employed, or a student planning to finance your bike, this calculator is your trusted financial companion.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the SBI Bank Bike Loan EMI Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The calculator uses a standard EMI formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N - 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P is the principal loan amount</li>
              <li>R is the monthly interest rate (annual rate divided by 12 x 100)</li>
              <li>N is the loan tenure in months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              Let’s assume you want a bike loan of ₹50,000 from SBI Bank at an interest rate of 10.5% per annum for a tenure of 3 years (36 months).<br />
              Loan Amount (P) = ₹50,000<br />
              Interest Rate (R) = 10.5% annually = 0.00875 monthly<br />
              Tenure (N) = 36 months<br />
              EMI = [50,000 x 0.00875 x (1+0.00875)^36] / [(1+0.00875)^36 - 1] = approx ₹1,623/month<br />
              This helps you pre-empt your monthly outflows and match them with your income.
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An Amortisation Schedule is a detailed table showing the breakdown of each EMI payment across the loan tenure. It tells you how much of each EMI goes towards interest and how much reduces the principal. Over time, the interest component decreases while the principal component increases. This schedule helps you visualise your repayment timeline, understand your outstanding balance at any point, and plan for pre-payments or foreclosures effectively.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>12-Month Amortisation Schedule (Sample for ₹50,000 at 10.5% p.a.):</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">Opening Balance</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Closing Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">50,000</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">438</td>
                    <td className="border px-4 py-2">3,957</td>
                    <td className="border px-4 py-2">46,043</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">46,043</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">404</td>
                    <td className="border px-4 py-2">3,991</td>
                    <td className="border px-4 py-2">42,052</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">42,052</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">368</td>
                    <td className="border px-4 py-2">4,027</td>
                    <td className="border px-4 py-2">38,025</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">38,025</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">333</td>
                    <td className="border px-4 py-2">4,062</td>
                    <td className="border px-4 py-2">33,963</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">33,963</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">298</td>
                    <td className="border px-4 py-2">4,097</td>
                    <td className="border px-4 py-2">29,866</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">29,866</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">262</td>
                    <td className="border px-4 py-2">4,133</td>
                    <td className="border px-4 py-2">25,733</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">25,733</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">226</td>
                    <td className="border px-4 py-2">4,169</td>
                    <td className="border px-4 py-2">21,564</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">21,564</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">190</td>
                    <td className="border px-4 py-2">4,205</td>
                    <td className="border px-4 py-2">17,359</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">17,359</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">152</td>
                    <td className="border px-4 py-2">4,243</td>
                    <td className="border px-4 py-2">13,116</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">13,116</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">114</td>
                    <td className="border px-4 py-2">4,281</td>
                    <td className="border px-4 py-2">8,835</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">8,835</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">75</td>
                    <td className="border px-4 py-2">4,320</td>
                    <td className="border px-4 py-2">4,515</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">4,515</td>
                    <td className="border px-4 py-2">4,395</td>
                    <td className="border px-4 py-2">36</td>
                    <td className="border px-4 py-2">4,359</td>
                    <td className="border px-4 py-2">156</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">Opening Balance(₹)</th>
          <th className="border px-4 py-2 text-left">EMI   (₹)</th>
          <th className="border px-4 py-2 text-left">Interest (₹)</th>
          <th className="border px-4 py-2 text-left"> Principal  (₹)</th>
          <th className="border px-4 py-2 text-left"> Close Balance  (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
       
          ["1", "₹50,000", "₹4,395", "₹438", "₹3,957", "₹46,043"],
          ["2", "₹46,043", "₹4,395", "₹404", "₹3,991", "₹42,052"],
          ["3", "₹42,052", "₹4,395", "₹368", "₹4,027", "₹38,025"],
          ["4", "₹38,025", "₹4,395", "₹333", "₹4,062", "₹33,963"],
          ["5", "₹33,963", "₹4,395", "₹298", "₹4,097", "₹29,866"],
          ["6", "₹29,866", "₹4,395", "₹262", "₹4,133", "₹25,733"],
          ["7", "₹25,733", "₹4,395", "₹226", "₹4,169", "₹21,564"],
          ["8", "₹21,564", "₹4,395", "₹190", "₹4,205", "₹17,359"],
          ["9", "₹17,359", "₹4,395", "₹152", "₹4,243", "₹13,116"],
          ["10", "₹13,116", "₹4,395", "₹114", "₹4,281", "₹8,835"],
          ["11", "₹8,835", "₹4,395", "₹75", "₹4,320", "₹4,515"],
          ["12", "₹4,515", "₹4,395", "₹36", "₹4,359", "₹156"]
     
        ].map(([month, emi, interest, principal, balance,close], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
            <td className="border px-4 py-2">{close}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
            ["1", "₹50,000", "₹4,395", "₹438", "₹3,957", "₹46,043"],
            ["2", "₹46,043", "₹4,395", "₹404", "₹3,991", "₹42,052"],
            ["3", "₹42,052", "₹4,395", "₹368", "₹4,027", "₹38,025"],
            ["4", "₹38,025", "₹4,395", "₹333", "₹4,062", "₹33,963"],
            ["5", "₹33,963", "₹4,395", "₹298", "₹4,097", "₹29,866"],
            ["6", "₹29,866", "₹4,395", "₹262", "₹4,133", "₹25,733"],
            ["7", "₹25,733", "₹4,395", "₹226", "₹4,169", "₹21,564"],
            ["8", "₹21,564", "₹4,395", "₹190", "₹4,205", "₹17,359"],
            ["9", "₹17,359", "₹4,395", "₹152", "₹4,243", "₹13,116"],
            ["10", "₹13,116", "₹4,395", "₹114", "₹4,281", "₹8,835"],
            ["11", "₹8,835", "₹4,395", "₹75", "₹4,320", "₹4,515"],
            ["12", "₹4,515", "₹4,395", "₹36", "₹4,359", "₹156"]
    ].map(([month, emi, interest, principal, balance, close], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">Opening Balance(₹):</span> {emi}</div>
        <div><span className="font-semibold">EMI  (₹):</span> {interest}</div>
        <div><span className="font-semibold">Interest  (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Principal (₹):</span> {balance}</div>
        <div><span className="font-semibold"> 	Close Balance(₹):</span> {close}</div>
      </div>
    ))}
  </div>
</div>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Bike Loan EMI
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Loan Amount:</strong> Higher the loan amount, higher will be the EMI.</li>
                <li><strong>Interest Rate:</strong> Small changes in interest rates can significantly affect the EMI.</li>
                <li><strong>Loan Tenure:</strong> Longer tenures reduce EMI but increase total interest paid.</li>
                <li><strong>Credit Score:</strong> A good CIBIL score may qualify you for lower interest rates.</li>
                <li><strong>Processing Fees:</strong> Though not included in EMI, upfront charges can affect overall cost.</li>
                <li><strong>Income Stability:</strong> Lenders evaluate your monthly income to determine eligibility.</li>
                <li><strong>Down Payment:</strong> A higher down payment reduces the principal loan amount.</li>
                <li><strong>Prepayment & Foreclosure:</strong> These can reduce interest outgo if done strategically.</li>
                <li><strong>Market Trends:</strong> RBI policies and inflation impact lending rates.</li>
                <li><strong>Bank Policies:</strong> Each bank has specific rules regarding EMIs and interest calculations.</li>
              </ul>
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                        {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default SbiBikeLoanEmiCalculator ;
